module.exports = __webpack_public_path__ + "img/unlock_info.f2a45f1b.svg";